export function createManualLock() {
    let locked = false;
    let resolveFn: (() => void) | null = null;
    let lockPromise: Promise<void> = Promise.resolve();

    return {
        lock() {
            if (!locked) {
                locked = true;
                lockPromise = new Promise<void>((resolve) => {
                    resolveFn = resolve;
                });
            }
        },
        unlock() {
            if (locked) {
                locked = false;
                if (resolveFn) {
                    resolveFn();
                    resolveFn = null;
                }
            }
        },
        async wait() {
            await lockPromise;
        },
        get isLocked() {
            return locked;
        },
    };
}